export var ApiResultCode;
(function (ApiResultCode) {
    ApiResultCode["SUCCESS"] = "SUCCESS";
    ApiResultCode["ERROR_PORTAL_DISABLED"] = "ERROR_PORTAL_DISABLED";
    ApiResultCode["ERROR_CANNOT_FIND_ITEM"] = "ERROR_CANNOT_FIND_ITEM";
    ApiResultCode["ERROR_CANNOT_FIND_USER"] = "ERROR_CANNOT_FIND_USER";
    ApiResultCode["ERROR_CANNOT_FIND_RESOURCE"] = "ERROR_CANNOT_FIND_RESOURCE";
    ApiResultCode["ERROR_CANNOT_FIND_ORGANIZATION"] = "ERROR_CANNOT_FIND_ORGANIZATION";
    ApiResultCode["ERROR_LOGIN_FAILED"] = "ERROR_LOGIN_FAILED";
    ApiResultCode["ERROR_MANUAL_LOGIN_FAILED"] = "ERROR_MANUAL_LOGIN_FAILED";
    ApiResultCode["ERROR_COOKIE_LOGIN_FAILED"] = "ERROR_COOKIE_LOGIN_FAILED";
    ApiResultCode["ERROR_COOKIE_LOGIN_FAILED_NOT_REGISTERED"] = "ERROR_COOKIE_LOGIN_FAILED_NOT_REGISTERED";
    ApiResultCode["ERROR_COOKIE_LOGIN_FAILED_NOT_ACTIVATED"] = "ERROR_COOKIE_LOGIN_FAILED_NOT_ACTIVATED";
    ApiResultCode["ERROR_AUTHENTICATION_FROM_TOKEN_FAILED"] = "ERROR_AUTHENTICATION_FROM_TOKEN_FAILED";
    ApiResultCode["ERROR_AUTHENTICATION_REQUIRED"] = "ERROR_AUTHENTICATION_REQUIRED";
    ApiResultCode["ERROR_SECURITY_ACCESS"] = "ERROR_SECURITY_ACCESS";
    ApiResultCode["ERROR_ITEM_NOT_PUBLISHED"] = "ERROR_ITEM_NOT_PUBLISHED";
    ApiResultCode["ERROR_INVALID_PAGINATION"] = "ERROR_INVALID_PAGINATION";
    ApiResultCode["ERROR_PAGINATION_NOT_SUPPORTED"] = "ERROR_PAGINATION_NOT_SUPPORTED";
    ApiResultCode["ERROR_INVALID_EMAIL"] = "ERROR_INVALID_EMAIL";
    ApiResultCode["ERROR_INVALID_FILTER"] = "ERROR_INVALID_FILTER";
    ApiResultCode["ERROR_INVALID_FILTER_ID"] = "ERROR_INVALID_FILTER_ID";
    ApiResultCode["ERROR_INVALID_ID"] = "ERROR_INVALID_ID";
    ApiResultCode["ERROR_REGISTRATION_NOT_ALLOWED"] = "ERROR_REGISTRATION_NOT_ALLOWED";
    ApiResultCode["ERROR_REGISTRATION_CUSTOMER_ALREADY_EXIST"] = "ERROR_REGISTRATION_CUSTOMER_ALREADY_EXIST";
    ApiResultCode["ERROR_SUBMIT_NAME_IS_REQUIRED"] = "ERROR_SUBMIT_NAME_IS_REQUIRED";
    ApiResultCode["ERROR_SUBMIT_DESCRIPTION_IS_REQUIRED"] = "ERROR_SUBMIT_DESCRIPTION_IS_REQUIRED";
    ApiResultCode["ERROR_SUBMIT_TYPE_IS_REQUIRED"] = "ERROR_SUBMIT_TYPE_IS_REQUIRED";
    ApiResultCode["ERROR_SUBMIT_TYPE_IS_WRONG"] = "ERROR_SUBMIT_TYPE_IS_WRONG";
    ApiResultCode["ERROR_SUBMIT_WRONG_PRIORITY"] = "ERROR_SUBMIT_WRONG_PRIORITY";
    ApiResultCode["ERROR_SUBMIT_PROJECT_NOT_FOUND"] = "ERROR_SUBMIT_PROJECT_NOT_FOUND";
    ApiResultCode["ERROR_SUBMIT_PROJECT_NOT_PUBLISHED"] = "ERROR_SUBMIT_PROJECT_NOT_PUBLISHED";
    ApiResultCode["ERROR_SUBMIT_ANONYMOUS_MUST_PROVIDE_EMAIL"] = "ERROR_SUBMIT_ANONYMOUS_MUST_PROVIDE_EMAIL";
    ApiResultCode["ERROR_USER_ALREADY_EXIST"] = "ERROR_USER_ALREADY_EXIST";
    ApiResultCode["ERROR_CANNOT_FIND_PARENT_POST"] = "ERROR_CANNOT_FIND_PARENT_POST";
    ApiResultCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiResultCode["UPLOAD_CANCEL"] = "UPLOAD_CANCEL";
    ApiResultCode["UPLOAD_ERROR"] = "UPLOAD_ERROR";
    ApiResultCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ApiResultCode["ERROR_CANNOT_FIND_CUSTOMER"] = "ERROR_CANNOT_FIND_CUSTOMER";
    ApiResultCode["ERROR_URI_NOT_SPECIFIED"] = "ERROR_URI_NOT_SPECIFIED";
    ApiResultCode["ERROR_LOGIN_WITH_WRONG_ORG"] = "ERROR_LOGIN_WITH_WRONG_ORG";
    ApiResultCode["ERROR_CREATE_CUSTOMER"] = "ERROR_CREATE_CUSTOMER";
})(ApiResultCode || (ApiResultCode = {}));
//# sourceMappingURL=api-result-code.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/http/api-result-code.js
// module id = 388
// module chunks = 14